import React, { useMemo } from "react";
import RegisterPage, { STATUS_BADGES, StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";
import { getExpiryStatus, calculateClosurePercent } from "../lib/hseCalc";

export default function Training() {
  const { data, siteNames } = useHSE();

  const rows = useMemo(
    () => (data.trainings || []).map((t) => ({ ...t, status: getExpiryStatus(t.expiryDate) })),
    [data.trainings]
  );

  const total = rows.length;
  const valid = rows.filter((t) => t.status === "Valid").length;
  const expiring = rows.filter((t) => t.status === "Expiring Soon").length;
  const expired = rows.filter((t) => t.status === "Expired").length;
  const compliance = calculateClosurePercent(valid, total);

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <StatCard label="Compliance %" value={`${compliance}%`} sub="Target 95%" tone={compliance >= 95 ? "safe" : "warning"} testid="trn-pct" />
      <StatCard label="Total Records" value={total} testid="trn-total" />
      <StatCard label="Expiring Soon (30d)" value={expiring} tone="warning" testid="trn-expiring" />
      <StatCard label="Expired" value={expired} tone="critical" testid="trn-expired" />
    </div>
  );

  const trainingTypes = data.settings.trainingTypes || [];

  return (
    <RegisterPage
      title="Training Matrix"
      subtitle="Employee training records with 30-day expiry alerts — ISO 45001 §7.2"
      storeKey="trainings"
      idPrefix="TRN"
      topPanels={Top}
      columns={[
        { key: "id", label: "ID" },
        { key: "employeeName", label: "Employee" },
        { key: "employeeId", label: "Emp ID" },
        { key: "iqama", label: "Iqama No" },
        { key: "contractor", label: "Company / Contractor" },
        { key: "trade", label: "Trade / Position" },
        { key: "site", label: "Site" },
        { key: "type", label: "Training Type" },
        { key: "trainer", label: "Trainer" },
        { key: "date", label: "Date" },
        { key: "expiryDate", label: "Expiry" },
        { key: "status", label: "Status / Authorization", render: (r) => {
            const val = getExpiryStatus(r.expiryDate);
            if (val === "Expired") {
              return <span className="cmd-pill bg-rose-100 text-rose-800 font-bold">Expired (Auth Suspended)</span>;
            }
            const m = STATUS_BADGES[val] || { bg: "#F1F5F9", color: "#455560" };
            return <span className="cmd-pill" style={{ background: m.bg, color: m.color }}>{val}</span>;
          }
        },
      ]}
      formFields={[
        { key: "id", label: "Training ID" },
        { key: "employeeName", label: "Employee Name" },
        { key: "employeeId", label: "Employee ID" },
        { key: "iqama", label: "Iqama Number" },
        { key: "contractor", label: "Company / Contractor" },
        { key: "trade", label: "Trade / Position" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "department", label: "Department", type: "select", options: data.settings.departments },
        { key: "type", label: "Training Type", type: "select", options: trainingTypes },
        { key: "trainer", label: "Trainer" },
        { key: "date", label: "Training Date", type: "date" },
        { key: "expiryDate", label: "Expiry Date", type: "date" },
      ]}
    />
  );
}
